
import { Options, Vue } from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import { dataModule } from '@/store/data';
import NText from '@/uikit/text/NText.vue';

@Options({
  name: 'TableItemCameras',
  components: { NText }
})
export default class TableItemCameras extends Vue {
  @Prop({ type: Array, required: true })
  readonly modelValue!: number[];

  content = '';

  @Watch('modelValue', { immediate: true })
  async load() {
    this.content = '...';
    const items = await dataModule.camerasModule.getByIds(this.modelValue);
    this.content = items.length ? items.map((v) => v.name).join(', ') : '-';
  }
}
